import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './estilo/global.css';
import { aplicarTemaSalvo } from './tema/tema.js';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html.');

// Antes de montar a interface: quem prefere claro não deve ver a tela escura piscar.
aplicarTemaSalvo();

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
